import Flickity from 'flickity';

const flkty = [];

function addSlider() {
  const inlineNavigations = document.querySelectorAll('.js-inline-navigation-slider');

  if (inlineNavigations && inlineNavigations.length > 0) {
    for (let i = 0; i < inlineNavigations.length; i += 1) {
      const current = inlineNavigations[i];
      setTimeout(() => {
        const currentFlkty = new Flickity(current, {
          cellAlign: 'left',
          contain: true,
          cellSelector: '.inline-navigation-item',
          pageDots: false,
        });

        flkty.push(currentFlkty);
      });
    }
  }
}

function removeSlider() {
  for (let i = 0; i < flkty.length; i += 1) {
    flkty[i].destroy();
  }
}

function checkMediaQuery(x) {
  if (x.matches) { // If media query matches
    removeSlider();
  } else {
    addSlider();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const mediaQuery = window.matchMedia('(min-width: 768px)');
  checkMediaQuery(mediaQuery); // Call listener function at run time
  mediaQuery.addListener(checkMediaQuery); // Attach listener function on state changes
});
